import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import { init, update, create } from './grupoActions';
import { refreshSessionPermissions } from '../auth/authActions';
import LabelAndInput from '../common/form/labelAndInput';
import PermissaoGrupo from '../permissao/permissaoList';
import { getList } from '../permissao/permissaoActions';
import Button from '../common/form/button';
import ProcessingOverlay from '../common/components/processingOverlay';

class GrupoForm extends Component {
  constructor(props) {
    super(props);

    this.geraGridPermissao = this.geraGridPermissao.bind(this);
    this.salvarGrupo = this.salvarGrupo.bind(this);
    this.handlePermissoesChange = this.handlePermissoesChange.bind(this);

    this.state = {
      show: false,
      permissao: [],
      loadingPermissoes: false,
    };
  }

  componentWillMount() {
    this.geraGridPermissao(this.props.grupoID);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.grupoID !== this.props.grupoID) {
      this.geraGridPermissao(this.props.grupoID);
    }
  }

  geraGridPermissao(grupoID) {
    if (!grupoID) {
      this.setState({ permissao: [], loadingPermissoes: false });
      return;
    }

    this.setState({ loadingPermissoes: true });

    this.props
      .getList(grupoID)
      .then(result => {
        this.setState({ permissao: result.payload.data, loadingPermissoes: false });
      })
      .catch(() => {
        this.setState({ loadingPermissoes: false });
      });
  }

  handlePermissoesChange(permissoes) {
    this.setState({ permissao: permissoes });
  }

  salvarGrupo() {
    this.setState({ show: true });
    this.props.valores.permissao = this.state.permissao;

    const promise =
      (this.props.valores.id !== null && this.props.valores.id !== undefined) ? this.props.update(this.props.valores) : this.props.create(this.props.valores);

    promise
      .then(() => {
        this.setState({ show: false });
        const grupoSalvoId = this.props.valores && this.props.valores.id;
        const meuGrupoId = this.props.currentUser && this.props.currentUser.grupo_idgrupo;
        this.props.init();
        if ((grupoSalvoId !== null && grupoSalvoId !== undefined) && (meuGrupoId !== null && meuGrupoId !== undefined) && String(grupoSalvoId) === String(meuGrupoId)) {
          this.props.refreshSessionPermissions();
        }
      })
      .catch(() => {
        this.setState({ show: false });
      });
  }

  render() {
    const premiumForm = this.props.premiumLayout === true;
    const showPermissoes = !premiumForm || (this.props.grupoID !== null && this.props.grupoID !== undefined);

    return (
      <div>
        <ProcessingOverlay
          show={this.state.show}
          message={
            <>
              Salvando grupo de usuários...
              <small>Aguarde, processando permissões.</small>
            </>
          }
          tagline="Cadastro de grupos"
        />

        <form className={premiumForm ? 'simple-cad-form-premium' : ''}>
          <div className={premiumForm ? 'simple-cad-premium-container' : 'box-body'}>
            <div className={premiumForm ? 'simple-cad-premium-card' : ''}>
              {premiumForm && (
                <div className="simple-cad-premium-header">
                  <h4>
                    <i className="fa fa-users" /> Grupo de Usuários
                  </h4>
                  <p>Defina o grupo e revise as permissões associadas a ele.</p>
                </div>
              )}
              <div className={premiumForm ? 'simple-cad-premium-body' : ''}>
                <Field
                  name="id"
                  component={LabelAndInput}
                  readOnly
                  label="Código"
                  cols={premiumForm ? '12 4' : '12'}
                  placeholder="Automático"
                />
                <Field
                  name="descricao"
                  component={LabelAndInput}
                  label="Descrição"
                  cols={premiumForm ? '12 8' : '12'}
                  placeholder="Informe a descrição"
                />
              </div>
            </div>
          </div>

          {showPermissoes && (
            <div className={premiumForm ? 'simple-cad-premium-section' : 'box-footer'}>
              {premiumForm && (
                <div className="simple-cad-premium-section-title">
                  <h5>
                    <i className="fa fa-lock" /> Permissões
                  </h5>
                  <span>Ative o acesso por tela e refine as ações permitidas para este grupo.</span>
                </div>
              )}
              <div className={premiumForm ? 'simple-cad-premium-permissions' : ''}>
                <PermissaoGrupo
                  permissoes={this.state.permissao}
                  onChange={this.handlePermissoesChange}
                  loading={this.state.loadingPermissoes}
                />
              </div>
            </div>
          )}

          <div className={premiumForm ? 'simple-cad-premium-footer' : 'box-footer'}>
            <Button type="button" className={this.props.submitClass} icon="check" label="Salvar" onClick={this.salvarGrupo} />
            <Button type="button" className="default" icon="close" label="Cancelar" onClick={this.props.init} />
          </div>
        </form>
      </div>
    );
  }
}

GrupoForm = reduxForm({ form: 'grupoForm', destroyOnUnmount: false })(GrupoForm);

const selector = formValueSelector('grupoForm');
const mapStateToProps = state => ({
  grupoID: selector(state, 'id'),
  valores: getFormValues('grupoForm')(state),
  currentUser: state.auth && state.auth.user,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ init, getList, update, create, refreshSessionPermissions }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(GrupoForm);
